import { useEffect, useState } from 'react';
import axios from 'axios';
import ApiDatabase from '../server';

/**
 * Hook personnalisé pour charger les compteurs de viviers et avis clients en parallèle
 * @param {boolean} refreshUntreated - Déclenche le rechargement des avis non traités
 * @returns {Object} { nbAllViviers, nbRatingUntreatedTempWorkers, isLoading }
 */
const useVivierCounts = (refreshUntreated = false) => {
  const [nbAllViviers, setNbAllViviers] = useState(0);
  const [nbRatingUntreatedTempWorkers, setNbRatingUntreatedTempWorkers] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const token = localStorage.getItem('xsrfToken');

  useEffect(() => {
    let isMounted = true;
    setIsLoading(true);

    // Charger les deux données en parallèle
    Promise.all([
      // Fetch nbAllViviers - utiliser le nouvel endpoint count optimisé
      axios({
        method: 'get',
        url: `${process.env.REACT_APP_API_URL}vivier/vivierCount`,
      })
        .then((res) => res.data.count || 0)
        .catch((err) => {
          if (err.name !== 'CanceledError') {
            console.log('Error fetching viviers count:', err);
          }
          return 0;
        }),
      // Fetch nbRatingUntreatedTempWorkers
      new Promise((resolve, reject) => {
        ApiDatabase.getNbRatingUntreatedTempWorkers(
          { token },
          (data) => resolve(data.nbReviews || 0),
          (err) => {
            if (err.name !== 'CanceledError') {
              console.log('Error fetching untreated ratings:', err);
            }
            resolve(0);
          }
        );
      }),
    ])
      .then(([viviersCount, ratingsCount]) => {
        if (isMounted) {
          setNbAllViviers(viviersCount);
          setNbRatingUntreatedTempWorkers(ratingsCount);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        if (err.name !== 'CanceledError' && isMounted) {
          console.log('Error in useVivierCounts:', err);
          setIsLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [refreshUntreated, token]);

  return {
    nbAllViviers,
    nbRatingUntreatedTempWorkers,
    isLoading,
  };
};

export default useVivierCounts;

